import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../Layout/Footer';
import Header from '../../../Layout/Header';
import feedback from '../../../../assets/img/notify.jpg';
import { Button, Form, Modal } from 'react-bootstrap';
import { useEffect } from 'react';
import { CancelTaskSeller, CompleteBuyer, getCompleteBuyer, getMyTaskListSeller, getOfferBuyer } from '../../../../Redux/Task/action';
import { useState } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { IMAGE_URL } from '../../../../api';
import { BiRupee } from 'react-icons/bi';
import SweetAlert from 'react-bootstrap-sweetalert';
import { viewUserProfile } from '../../../../Redux/User/action';
import loader from '../../../../assets/img/loader.gif';
import ToasterMessage from '../../../ToasterMessage';

const MytaskListingSeller = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [assign, setAssign] = useState([]);
    const [tasks, setTasks] = useState([])
    const [isswal, setIsswal] = useState(false);
    const [user, setUser] = useState({});
    const [isloader, setIsloader] = useState(false);
    const [toaster, setToaster] = useState("");
    useEffect(() => {

        let formData = new FormData();
        formData.append('status_object', 2);
        formData.append('limit', 12);
        // formData.append('sort_order', 1);
        // formData.append('category', 1);
        getMyTaskListSeller({ formData })((response) => {
            if (response && response.status) {
                setTasks(response?.data?.data)
            }
        });
        viewUserProfile()((response) => {
            if (response && response.status) {
                setUser(response?.data?.data[0])
            }
        });
    }, []);
    const validationSchema = Yup.object().shape({
        cancel_reason: Yup.string()
            .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            cancel_reason: "",
        },
        validationSchema,
        onSubmit: (values) => {
            setIsloader(true)
            const task_details = state?.data?.task_details?.id ? state?.data?.task_details?.id : state?.data?.task_details
            // formData.append("cancel_reason", values.cancel_reason);
            CancelTaskSeller(task_details, values?.cancel_reason)((response) => {
                if (response && response.status) {
                    setToaster("Post Task")
                    setTimeout(() => {
                        setToaster("")

                    }, 2000);
                    setIsloader(false)

                    navigate("/mytaskseller")
                }
                else {
                    setIsloader(false)
                }

            });
        },
    });
    // const onCancelTask = () => {
    //     var task_details = state?.data?.task_details?.task?.id;
    //     CancelTaskSeller({ task_details })((response) => {
    //         if (response && response.status) {
    //             // getAssignedBuyer()
    //         }
    //     });
    // }
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const onCompleteSweetAlert = () => {
        setIsswal(true);
    }
    const onCompleteBuyer = () => {
        var task_details = state?.data?.task_details?.id ? state?.data?.task_details?.id : state?.data?.task_details;
        CompleteBuyer({ task_details })((response) => {
            if (response && response.status) {
                navigate('/mytaskseller', { state: { toaster: true } })

            }
        });
    }

    const downloadInvoice = (download) => {
        var a = document.createElement('a')
        a.href = IMAGE_URL + download
        a.target = '_blank'
        // a.download = 
        a.click();
    }

    const handleClickUserTask = () => {
        const sellerEmail = user?.user?.email;
        const buyerEmail = state?.data?.task_details?.user_data?.[0]?.email || state?.data?.task_details?.posted_by?.email;
        const recieverObj = state?.data?.task_details?.user_data?.[0] || state?.data?.task_details?.posted_by;
        navigate('/chat/', { state: { collection: sellerEmail + state?.data?.task_details?.id + buyerEmail + state?.data?.task_details?.id, reciever: recieverObj, task_detail: state?.data?.task_details?.id, task_detail_id: state?.data?.id } })
    }

    return (
        <React.Fragment>
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>My Task </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Task Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mytask-details">
                <div className="container">
                    <div className="row task-details-main">
                        <div className='col-lg-12'>

                            <div className=''>

                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className='task-details-flex'>
                                            <h5>{state?.data?.task_status?.title ? state?.data?.task_status?.title : state?.data?.task_details?.title}</h5>

                                        </div>
                                        <h6>Posted on: {moment(state?.data?.task_details?.created_date).format('ll')}</h6>
                                        <h6>Posted by: <span style={{ color: "#1bbaed", fontWeight: "700" }}>{state?.data?.task_status?.posted_by ? state?.data?.task_status?.posted_by : state?.data?.task_details?.posted_by?.username}</span></h6>
                                        <h6>Due date: {moment(state?.data?.task_details?.date_choice).format('ll')}</h6>

                                        {state?.data?.task_details?.location &&
                                            <p><i class="bi bi-geo-alt-fill me-2"></i>{state?.data?.task_details?.location}</p>
                                        }
                                        <div className='chat_dots' onClick={() => handleClickUserTask()}>
                                            <p>Click here to chat with {state?.data?.task_status?.posted_by ? state?.data?.task_status?.posted_by : state?.data?.task_details?.posted_by?.username}</p><i class="bi bi-chat-dots"></i>
                                        </div>

                                    </div>
                                    <div className='col-lg-6'>
                                        <div className='service-desc'>
                                            <h5>Service Description</h5>
                                            <p>{state?.data?.task_details?.description ? state?.data?.task_details?.description : state?.data?.task_status?.description}</p>

                                        </div>
                                        {/* {state?.data?.seller_details && state?.data?.seller_details[0]?.bid_rate != "" || state?.data?.assigned_data && state?.data?.assigned_data[0]?.bid_rate ?
                                            <div className="member-info">
                                                <p>Bid rate: <BiRupee size="20" style={{ color: "#000" }} />{parseFloat(state?.data?.assigned_data && state?.data?.assigned_data[0]?.bid_rate ? state?.data?.assigned_data && state?.data?.assigned_data[0]?.bid_rate : state?.data?.seller_details && state?.data?.seller_details[0]?.bid_rate).toFixed(1)}</p>
                                            </div> : null
                                        }
                                        {state?.data?.seller_details && state?.data?.seller_details[0]?.chat_rate != "" || state?.data?.assigned_data && state?.data?.assigned_data[0]?.chat_rate ?
                                            <div className="member-info">
                                                <p>Chat rate: <BiRupee size="20" style={{ color: "#000" }} />{parseFloat(state?.data?.assigned_data && state?.data?.assigned_data[0]?.chat_rate ? state?.data?.assigned_data[0]?.chat_rate : state?.data?.seller_details && state?.data?.seller_details[0]?.chat_rate).toFixed(1)}</p>
                                                <p>Call rate: <BiRupee size="20" style={{ color: "#000" }} />{parseFloat(state?.data?.assigned_data && state?.data?.assigned_data[0]?.call_rate ? state?.data?.assigned_data[0]?.call_rate : state?.data?.seller_details && state?.data?.seller_details[0]?.call_rate).toFixed(1)} / {state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 1 ? "hour" : state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 2 ? "min" : state?.data?.seller_details && state?.data?.seller_details[0]?.time_field == 1 ? "hour" : state?.data?.assigned_data?.time_field == 1 ? "hour" : state?.data?.seller_details && state?.data?.seller_details[0]?.time_field == 2 && "min"}</p>
                                               
                                            </div> : null
                                        } */}
                                        {state?.data?.assigned_price && state?.data?.assigned_price?.bid_rate != "" || state?.data?.assigned_data && state?.data?.assigned_data[0]?.bid_rate ?
                                            <div className="member-info">
                                                <p>Bid rate: <BiRupee size="20" style={{ color: "#000" }} />{parseFloat(state?.data?.assigned_data && state?.data?.assigned_data[0]?.bid_rate ? state?.data?.assigned_data && state?.data?.assigned_data[0]?.bid_rate : state?.data?.assigned_price && state?.data?.assigned_price?.bid_rate).toFixed(1)}</p>
                                            </div> : null
                                        }
                                        {state?.data?.assigned_price && state?.data?.assigned_price?.chat_rate != "" || state?.data?.assigned_data && state?.data?.assigned_data[0]?.chat_rate ?
                                            <div className="member-info">
                                                <p>Chat rate: <BiRupee size="20" style={{ color: "#000" }} />{parseFloat(state?.data?.assigned_data && state?.data?.assigned_data[0]?.chat_rate ? state?.data?.assigned_data[0]?.chat_rate : state?.data?.assigned_price && state?.data?.assigned_price?.chat_rate).toFixed(1)}</p>
                                                <p>Call rate: <BiRupee size="20" style={{ color: "#000" }} />{parseFloat(state?.data?.assigned_data && state?.data?.assigned_data[0]?.call_rate ? state?.data?.assigned_data[0]?.call_rate : state?.data?.assigned_price && state?.data?.assigned_price?.call_rate).toFixed(1)} / {state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 1 ? "hour" : state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 2 ? "min" : state?.data?.seller_details && state?.data?.seller_details[0]?.time_field == 1 ? "hour" : state?.data?.assigned_data?.time_field == 1 ? "hour" : state?.data?.seller_details && state?.data?.seller_details[0]?.time_field == 2 && "min"}</p>

                                            </div> : null
                                        }

                                        {state?.data?.attached_files != "" &&
                                            <div className='download-btn'>
                                                <p className='m-0'>Related Files</p>
                                                {state?.data?.attached_files.map((i) =>

                                                    <button className='badge badge-light-danger border-0 p-2 fs-7' onClick={() => downloadInvoice(i.file)}>

                                                        Download
                                                    </button>
                                                )
                                                }
                                            </div>
                                        }
                                        <div className='offers'>
                                            <div className='offers-link'>
                                                <div className="offfer-btn">
                                                    <div className=''>
                                                        <Button className='offers-assignbtn' variant="primary" onClick={handleShow}>Cancel Task</Button>
                                                    </div>
                                                    <div className=''>
                                                        <Button className='offers-assignbtn' variant="primary" onClick={() => onCompleteSweetAlert()}>Complete Task</Button>
                                                        {/* <Button className='offers-assignbtn' variant="primary" onClick={() => onCompleteBuyer(state?.data?.task_details?.id)}>Complete Task</Button> */}
                                                    </div>
                                                    {isswal &&
                                                        <SweetAlert
                                                            showCancel
                                                            reverseButtons={true}
                                                            confirmBtnText="Yes, complete it!"
                                                            confirmBtnBsStyle="danger"
                                                            title="Are you sure?"
                                                            onConfirm={() => onCompleteBuyer(state?.data?.task_details?.id ? state?.data?.task_details?.id : state?.data?.task_details)}
                                                            onCancel={() => setIsswal(false)}
                                                            closeOnClickOutside={false}
                                                            focusCancelBtn
                                                        >
                                                        </SweetAlert>
                                                    }
                                                </div>

                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </div>
                            {/* {tasks?.map((task, index) => */}

                            {/* )} */}
                            <Modal show={show} onHide={handleClose}>
                                <Modal.Header closeButton>

                                </Modal.Header>
                                <Modal.Body>
                                    <Form onSubmit={formik.handleSubmit}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                            <Form.Label style={{ fontSize: "16px", fontWeight: "600" }}>Cancel Reason</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name='cancel_reason'
                                                value={formik.values?.cancel_reason}
                                                onChange={formik.handleChange}
                                                rows={3}
                                                required
                                                maxLength={300}
                                            />
                                        </Form.Group>
                                        <div className='offers text-center'>
                                            {isloader == true ?
                                                <div className='loader'>
                                                    <img src={loader} alt="" className='img-fluid' />
                                                </div>
                                                :
                                                <Button type="submit" variant="primary" className='offers-assignbtn btn btn-primary'>
                                                    Submit
                                                </Button>
                                            }
                                        </div>

                                    </Form>
                                </Modal.Body>
                            </Modal>
                        </div>
                        <div className='col-lg-6'>

                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment >
    )
}

export default MytaskListingSeller;